import {NgModule} from '@angular/core';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';
import {MatCheckbox} from '@angular/material/checkbox';
import {UserSubRegionSelection} from './user-sub-region-selection/user-sub-region-selection';
import {NgIf} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
    declarations: [
        UserSubRegionSelection
    ],
  imports: [
    DropdownModule,
    CheckboxModule,
    MatCheckbox,
    NgIf,
    ReactiveFormsModule,
  ],
    providers: [],
    exports: [
        UserSubRegionSelection
    ]
})
export class HeaderModule {}
